import {useQuery, UseQueryOptions} from "react-query";
import Alert from "react-s-alert";

import {
  FacilityWorkflowsResponse,
  WorkflowService,
} from "../../../services/WorkflowService";

export const facilityWorkflowsQueryKey = (facilityId?: string) =>
  ["facilityWorkflows", facilityId ?? "default"] as const;

type QueryConfig = Omit<
  UseQueryOptions<
    FacilityWorkflowsResponse,
    unknown,
    FacilityWorkflowsResponse,
    ReturnType<typeof facilityWorkflowsQueryKey>
  >,
  "queryKey" | "queryFn"
>;

/**
 * Loads enabled workflow types for a facility via the latest template version.
 *
 * When `facilityId` is omitted, falls back to admission only.
 */
export const useFacilityWorkflowsQuery = (
  facilityId?: string,
  queryConfig: QueryConfig = {},
) =>
  useQuery(
    facilityWorkflowsQueryKey(facilityId),
    () => WorkflowService.getFacilityWorkflows(facilityId ?? ""),
    {
      enabled: facilityId === undefined || Boolean(facilityId),
      onError: () =>
        Alert.error(
          "Failed to load workflows for this facility. Please, try again later.",
        ),
      ...queryConfig,
    },
  );
